export default __webpack_public_path__ + "static/media/lds-logo_sl.d7d62157f604ee03.svg";